import React, { useEffect, useState } from 'react';
import { Card, Container, Row } from 'reactstrap';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useDict } from '../../../contexts/LanguageContext';
import {
    getFirstTimeOptions,
    getRetrieveDeclaration,
    postSubmitAgreeTermsForm,
    postSubmitBankAccForm,
    postSubmitWealthDeclarationForm,
} from '../src/firstTimeDashboardApis';
import BankAccount from './BankAccount';
import Completed from './Completed';
import TNC from './TNC';
import WealthDeclaration from './WealthDeclaration';

const WizardForm = () => {
    const dict = useDict();

    const [pageNum, setPageNum] = useState(1);
    const [banks, setBanks] = useState([]);
    const [bankAccountTypes, setBankAccountTypes] = useState([]);
    const [countries, setCountries] = useState([]);
    const [bankAcc, setBankAcc] = useState([]);
    const [wealthDeclaration, setWealthDeclaration] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [isAgree, setIsAgree] = useState(false);
    const [employmentStatuses, setEmploymentStatuses] = useState([]);
    const [jobCategories, setJobCategories] = useState([]);
    const [annualIncomeRanges, setAnnualIncomeRanges] = useState([]);
    const [netWorthRanges, setNetWorthRanges] = useState([]);
    const [sourcesOfWealth, setSourcesOfWealth] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);

        getDropdownList();
        getFirstTimeDashboardSubmittedData();

        setIsLoading(false);
    }, []);

    useEffect(() => {
        setIsLoading(true);

        getFirstTimeDashboardSubmittedData();

        setIsLoading(false);
    }, [pageNum]);

    const onGoToPreviousPage = () => {
        setPageNum(pageNum - 1);
    }

    const handleGetFirstTimeOptions = (response) => {
        const { data: responseData } = response.data;

        setBanks(responseData.banks);
        setBankAccountTypes(responseData.bank_account_types);
        setCountries(responseData.countries);
        setEmploymentStatuses(responseData.employment_statuses);
        setJobCategories(responseData.job_categories);
        setAnnualIncomeRanges(responseData.annual_income_ranges);
        setNetWorthRanges(responseData.net_worth_ranges);
        setSourcesOfWealth(responseData.sources_of_wealths);
    }

    const getDropdownList = () => {
        getFirstTimeOptions(handleGetFirstTimeOptions);
    }

    const handleGetFirstTimeDashboardSubmittedData = (response) => {
        const { data: responseData } = response.data;

        setBankAcc(responseData.bank_acc);
        setWealthDeclaration(responseData.wealth_declaration);
        setSubmitted(responseData.submitted);
        setIsAgree(responseData.wealth_declaration?.is_agree);
    }

    const getFirstTimeDashboardSubmittedData = () => {
        getRetrieveDeclaration(handleGetFirstTimeDashboardSubmittedData);
    }

    const handleSubmitBankAccForm = (response) => {
        setPageNum(pageNum + 1);
    }

    const onSubmitBankAccForm = async (values) => {
        setIsLoading(true);

        await postSubmitBankAccForm(values, handleSubmitBankAccForm);

        setIsLoading(false);
    }

    const handleSubmitWealthDeclarationForm = (response) => {
        setPageNum(pageNum + 1);
    }

    const onSubmitWealthDeclarationForm = async (values) => {
        var requestData;

        const employmentId = values.employment_id;

        switch (employmentId) {
            case 1:
                requestData = {
                    employment_status_id: employmentId,
                    company_name: values.company_name,
                    job_category_id: values.job_category_id,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    is_pep: values.pep_declare,
                };
                break;
            case 2:
                requestData = {
                    employment_status_id: employmentId,
                    company_name: values.company_name,
                    job_category_id: values.job_category_id,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    is_pep: values.pep_declare,
                };
                break;
            case 3:
                requestData = {
                    employment_status_id: employmentId,
                    previous_company_name: values.company_name,
                    previous_job_category_id: values.job_category_id,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    is_pep: values.pep_declare,
                };
                break;
            case 4:
                requestData = {
                    employment_status_id: employmentId,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    source_of_wealth_id: values.source_of_wealth,
                    is_partner_employed: values.spouseEmployed,
                    partner_company_name: values.company_name,
                    partner_job_category_id: values.job_category_id,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    is_pep: values.pep_declare,
                };
                break;
            case 5:
                requestData = {
                    employment_status_id: employmentId,
                    previous_company_name: values.company_name,
                    previous_job_category_id: values.job_category_id,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    is_previously_employed: values.employedPrevious,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    source_of_wealth_id: values.source_of_wealth,
                    is_pep: values.pep_declare,
                };
                break;
            default:
                requestData = {
                    employment_status_id: employmentId,
                    company_name: values.company_name,
                    job_category: values.job_category_id,
                    net_worth_range_id: values.networth_id,
                    annual_income_range_id: values.annual_income,
                    is_thailand_tax: values.check_tax_declare,
                    is_agree_risk_disclosure: '1',
                    angel_mban_member: values.MBAM_Investor,
                    is_pep: values.pep_declare,
                }
        }

        await postSubmitWealthDeclarationForm(requestData, handleSubmitWealthDeclarationForm);
    }

    const handleSubmitAgreeTerms = (response) => {
        setPageNum(pageNum + 1);
    }

    const onSubmitTnCForm = (values) => {
        postSubmitAgreeTermsForm(values, handleSubmitAgreeTerms);
    }

    return (
        <>
            {isLoading && <LoadingSpinner />}
            <Container className="dashboard">
                <Row md={12}>
                    <Card className="registration_card">
                        <div className="wizard">
                            <div className="wizard__steps">
                                <div
                                    className={`wizard__step${pageNum === 1 ? ' wizard__step--active' : ''
                                        }`}
                                >
                                    <p>{dict.bankAccount}</p>
                                </div>
                                <div
                                    className={`wizard__step${pageNum === 2 ? ' wizard__step--active' : ''
                                        }`}
                                >
                                    <p>{dict.wealthDeclaration}</p>
                                </div>
                                <div
                                    className={`wizard__step${pageNum === 3 ? ' wizard__step--active' : ''
                                        }`}
                                >
                                    <p>{dict.termsAndConditions}</p>
                                </div>
                                <div
                                    className={`wizard__step${pageNum === 4 ? ' wizard__step--active' : ''
                                        }`}
                                >
                                    <p>{dict.completed}</p>
                                </div>
                            </div>
                            <div className="wizard__form-wrapper">
                                {pageNum === 1 && (
                                    <BankAccount
                                        onSubmit={onSubmitBankAccForm}
                                        banks={banks}
                                        bankAccountTypes={bankAccountTypes}
                                        countries={countries}
                                        bankAcc={bankAcc}
                                        setIsLoading={setIsLoading}
                                    />
                                )}
                                {pageNum === 2 && (
                                    <WealthDeclaration
                                        previousPage={onGoToPreviousPage}
                                        onSubmit={onSubmitWealthDeclarationForm}
                                        wealthDeclaration={wealthDeclaration}
                                        employmentStatuses={employmentStatuses}
                                        jobCategories={jobCategories}
                                        annualIncomeRanges={annualIncomeRanges}
                                        netWorthRanges={netWorthRanges}
                                        source={sourcesOfWealth}
                                    />
                                )}
                                {pageNum === 3 && (
                                    <TNC
                                        previousPage={onGoToPreviousPage}
                                        onSubmit={onSubmitTnCForm}
                                        submitted={submitted}
                                        isAgree={isAgree}
                                    />
                                )}
                                {pageNum === 4 &&
                                    <Completed />
                                }
                            </div>
                        </div>
                    </Card>
                </Row>
            </Container>
        </>
    );
};

export default WizardForm;
